<form class="container-fluid">
  <!-- All Resource  === embeddedComponent version -->
  <ng-container *ngIf="embeddedComponent; else showFullPage">
    <div class="checks row">
      <div class="text-center col-3 pointer">
        <a title="Clear All" (click)="checkAll(false)" (keyup.enter)="checkAll(false)" tabindex="0">
          <i class="fa fa-lg fa-square-o"></i>
        </a>
      </div>
      <div class="text-center col-3 pointer">
        <a title="Check All" (click)="checkAll(true)" (keyup.enter)="checkAll(true)" tabindex="0">
          <i class="fa fa-lg fa-check-square-o"></i>
        </a>
      </div>
      <div class="text-center col-3 pointer">
        <a title="Reset to Default" (click)="resetAll()" (keyup.enter)="resetAll()" tabindex="0">
          <i class="fa fa-lg fa-retweet"></i>
        </a>
      </div>
      <div class="text-center col-3 pointer">
        <a
          title="Collapse All"
          tabindex="0"
          (click)="toggleExpandCollapse()"
          (keyup.enter)="toggleExpandCollapse()"
        >
          <i [ngClass]="showCollapseAll ? 'fa fa-lg fa-compress' : 'fa fa-lg fa-expand'"></i>
        </a>
      </div>
    </div>

    <!-- Home Components Layout -->
    <div class="row">
      <div *ngFor="let item of resourcesAS; let i = index" class="width-100 compPadding">
        <div class="adv-header2 margin-5-0" style="padding-left: 0px">
          <input
            type="checkbox"
            [id]="'home2' + i + item.id"
            [attr.title]="item.id"
            [value]="item.id"
            [checked]="item.isDefault"
            [indeterminate]="item.checkedStatus === PARTIAL_CHECKED"
            (click)="checkGroup($event, item.searchTargets)"
            (keyup.enter)="checkGroup($event, item.searchTargets)"
          />
          <span class="custom-control-description font-0-8" [innerHTML]="item.heading"></span>
          <i
            aria-hidden="true"
            (click)="toggleGroup(item)"
            (keyup.enter)="toggleGroup(item)"
            title="Show or Hide Resources"
            class="fa fa-sm fa-expand"
            tabindex="0"
          ></i>
        </div>
        <div *ngIf="!item.isCollapse" class="resources-main2">
          <div
            *ngFor="let resource of item.searchTargets; let j = index"
            class="resource-ulist2 col-12 font-0-8"
          >
            <ng-container *ngIf="resource.targetType === 'WL'">
              <a
                class="resource-links"
                (click)="openUrl(resource.targetUrl)"
                (keyup.enter)="openUrl(resource.targetUrl)"
                tabindex="0"
              >
                <div
                  [innerHTML]="resource.targetName"
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                ></div>
              </a>
            </ng-container>
            <ng-container
              *ngIf="
                resource.targetType !== 'WL' &&
                (resource?.noteUrl === null || resource?.noteUrl === '')
              "
            >
              <input
                type="checkbox"
                [id]="resource.libraryDBpoolKey"
                [value]="resource.libraryDBpoolKey"
                [attr.title]="resource.targetName"
                [checked]="resource.isDefault"
                (click)="checkResource($event, resource)"
                (keyup.enter)="checkResource($event, resource)"
              />
              <span class="custom-control-description">
                <div
                  [innerHTML]="resource.targetName"
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                ></div>
                <i
                  *ngIf="resource.targetDescription"
                  class="resource-icon fa fa-comment-o"
                  aria-hidden="true"
                  [matTooltip]="resource.targetDescription"
                >
                </i>
              </span>
            </ng-container>
            <ng-container
              *ngIf="
                resource.targetType !== 'WL' &&
                resource?.noteUrl !== null &&
                resource?.noteUrl !== ''
              "
            >
              <input
                type="checkbox"
                [id]="resource.libraryDBpoolKey"
                [value]="resource.libraryDBpoolKey"
                [attr.title]="resource.targetName"
                [checked]="resource.isDefault"
                (click)="checkResource($event, resource)"
                (keyup.enter)="checkResource($event, resource)"
              />
              <span class="custom-control-description">
                <a
                  class="resource-links-2"
                  tabindex="0"
                  (click)="openLink(resource?.noteUrl)"
                  (keyup.enter)="openLink(resource?.noteUrl)"
                >
                  <div
                    [innerHTML]="resource.targetName"
                    style="cursor: pointer; text-decoration: underline"
                    class="d-inline-block"
                  ></div>
                </a>
                <i
                  *ngIf="resource.targetDescription"
                  class="resource-icon fa fa-comment-o"
                  aria-hidden="true"
                  [matTooltip]="resource.targetDescription"
                >
                </i>
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- ALL RESOURCE == other versions -->
  <ng-template #showFullPage>
    <div class="checks row">
      <div class="text-center col-6 col-md-3">
        <!-- removed class active as per paul's new changes -->
        <span
          class="pointer"
          title="Clear All"
          (click)="checkAll(false)"
          (keyup.enter)="checkAll(false)"
          tabindex="0"
        >
          <i class="fa fa-lg fa-square-o"></i>
          <span> Clear All</span>
        </span>
      </div>
      <div class="text-center col-6 col-md-3">
        <span
          class="pointer"
          title="Check All"
          (click)="checkAll(true)"
          (keyup.enter)="checkAll(true)"
          tabindex="0"
        >
          <i class="fa fa-lg fa-check-square-o"></i>
          <span> Check All</span>
        </span>
      </div>
      <div class="text-center col-6 col-md-3">
        <span
          class="pointer"
          title="Reset to Default"
          (click)="resetAll()"
          (keyup.enter)="resetAll()"
          tabindex="0"
        >
          <i class="fa fa-lg fa-retweet"></i>
          <span> Set Default</span>
        </span>
      </div>
      <div class="text-center col-6 col-md-3">
        <span
          class="pointer"
          title="{{ showCollapseAll ? 'Collapse All' : 'Expand All' }}"
          (click)="toggleExpandCollapse()"
          (keyup.enter)="toggleExpandCollapse()"
          tabindex="0"
          ><i [ngClass]="showCollapseAll ? 'fa fa-lg fa-compress' : 'fa fa-lg fa-expand'"></i>
          <span>{{ showCollapseAll ? 'Collapse All' : 'Expand All' }}</span>
        </span>
      </div>
    </div>

    <!-- Advanced Search Layout -->
    <div class="row" id="gridclass">
      <div
        *ngFor="let item of resourcesAS; let i = index"
        class="width-100"
        style="border-bottom: 1px solid var(--shade-three)"
      >
        <div class="adv-header2 resource-group2 margin-5-0">
          <label>
            <input
              type="checkbox"
              [id]="'adv2' + i + item.id"
              [attr.title]="item.id"
              [value]="item.id"
              [checked]="item.isDefault"
              [indeterminate]="item.checkedStatus === PARTIAL_CHECKED"
              (click)="checkGroup($event, item.searchTargets)"
              (keyup.enter)="checkGroup($event, item.searchTargets)"
            />
            <span class="custom-control-indicator"></span>
            <div
              class="custom-control-description font-size-09 d-inline-block"
              [innerHTML]="item?.heading | addStyleToHtml"
            ></div>
          </label>
          <i
            aria-hidden="true"
            (click)="toggleGroup(item)"
            (keyup.enter)="toggleGroup(item)"
            title="Show or Hide Resources"
            [ngClass]="!item.isCollapse ? 'fa fa-sm fa-compress' : 'fa fa-sm fa-expand'"
            tabindex="0"
          ></i>
        </div>
        <div *ngIf="!item.isCollapse" class="resources-main2">
          <div
            *ngFor="let resource of item.searchTargets; let j = index"
            class="resource-ulist2 col-12 col-sm-6 col-lg-4"
          >
            <ng-container *ngIf="resource.targetType === 'WL'">
              <a
                class="resource-links"
                (click)="openUrl(resource.targetUrl)"
                (keyup.enter)="openUrl(resource.targetUrl)"
                tabindex="0"
              >
                <div
                  [innerHTML]="resource.targetName"
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                ></div>
              </a>
            </ng-container>
            <ng-container
              *ngIf="
                resource.targetType !== 'WL' &&
                (resource?.noteUrl === null || resource?.noteUrl === '')
              "
            >
              <label>
                <input
                  type="checkbox"
                  [id]="resource.libraryDBpoolKey"
                  [value]="resource.libraryDBpoolKey"
                  [attr.title]="resource.libraryDBpoolKey"
                  [checked]="resource.isDefault"
                  (click)="checkResource($event, resource)"
                  (keyup.enter)="checkResource($event, resource)"
                />
                <span>
                  <div
                    [innerHTML]="resource.targetName"
                    style="cursor: pointer; text-decoration: underline"
                    class="d-inline-block"
                  ></div>
                  <i
                    *ngIf="resource.targetDescription"
                    class="resource-icon fa fa-comment-o"
                    aria-hidden="true"
                    [matTooltip]="resource.targetDescription"
                  ></i>
                </span>
              </label>
            </ng-container>
            <ng-container
              *ngIf="
                resource?.targetType !== 'WL' &&
                resource?.noteUrl !== null &&
                resource?.noteUrl !== ''
              "
            >
              <label>
                <input
                  type="checkbox"
                  [id]="resource.libraryDBpoolKey"
                  [value]="resource.libraryDBpoolKey"
                  [attr.title]="resource.libraryDBpoolKey"
                  [checked]="resource.isDefault"
                  (click)="checkResource($event, resource)"
                  (keyup.enter)="checkResource($event, resource)"
                />
                <span>
                  <a
                    class="resource-links-2"
                    tabindex="0"
                    (click)="openLink(resource?.noteUrl)"
                    (keyup.enter)="openLink(resource?.noteUrl)"
                  >
                    <div
                      [innerHTML]="resource.targetName"
                      style="cursor: pointer; text-decoration: underline"
                      class="d-inline-block"
                    ></div>
                  </a>
                  <i
                    *ngIf="resource.targetDescription"
                    class="resource-icon fa fa-comment-o"
                    aria-hidden="true"
                    [matTooltip]="resource.targetDescription"
                  >
                  </i>
                </span>
              </label>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</form>
